import React from 'react';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Grid, Typography } from '@material-ui/core';
import firebase from '../../utils/firebase';
import { openAuthModal, closeAuthModal } from '../../actions/metaAction'
import logo from '../Nav/newlogo.png'

function AuthDialog(props) {

  const uiConfig = {
    signInFlow: 'popup',
    signInOptions: [
      // firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
      {
        provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
        defaultCountry: 'IN'
      }
    ],
    callbacks: {
      signInSuccessWithAuthResult: () => true
    }
  };


  return (
    <Dialog
      ref={React.createRef()}
      open={Boolean(props.isAuthModalOpen)}
      onClose={props.closeAuthModal}
      aria-labelledby="Login"
      aria-describedby="Login to continue"
    >
      <DialogTitle id="alert-dialog-title">
        <Grid item xs={12} style={{ display: "flex", justifyContent: 'center' }}>
          <img src={logo} height="40px" alt="DESI COOKS LOGO" />
        </Grid>
        <Typography component="p" variant="body1" align="center" color="primary">
          Login
      </Typography>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} justify="center" >
          <Grid item xs={12}>
            <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()} />
          </Grid>
          <Grid item xs={12}>
            <Typography component="p" variant="caption" align="center" color="primary">
              By continuing you agree to our <Link to="/privacy">privacy policy</Link> and <Link to="/terms">terms & conditions</Link>.
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.closeAuthModal} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const mapStateToProps = (state) => {
  return {
    isAuthModalOpen: state.meta.isAuthModalOpen
  }
}

export default connect(mapStateToProps, { openAuthModal, closeAuthModal })(AuthDialog)